"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

var _reactXarrows = _interopRequireDefault(require("react-xarrows"));

var _SankeyNode = _interopRequireDefault(require("./SankeyNode"));

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function useForceUpdate() {
  const [value, setValue] = (0, _react.useState)(0); // integer state

  return () => setValue(value => value + 1); // update the state to force render
}

function Sankey(_ref) {
  let {
    graph,
    height,
    width
  } = _ref;

  const randomInt = (max, min) => Math.round(Math.random() * (max - min)) + min;

  const [draw, setDraw] = (0, _react.useState)(false);
  const forceUpdate = useForceUpdate();
  (0, _jquery.default)(window).resize(function () {
    if (this.resizeTO) clearTimeout(this.resizeTO);
    this.resizeTO = setTimeout(function () {
      (0, _jquery.default)(this).trigger('resizeEnd');
    }, 500);
  }); //redraw graph when window resize is completed  

  (0, _jquery.default)(window).on('resizeEnd', function () {
    forceUpdate();
  });
  const graphHEIGHT = 500;
  let nodeSize = 40;
  let nodesMap = {};
  let edges = [];
  let nodesColorMap = {};
  const edgeMaxWidth = nodeSize - 5;
  const edgeMinWidth = 5;
  let maxEdgeApi = 0;
  let minEdgeApi = 99999999999999999;

  const mapRange = (input, input_start, input_end, output_start, output_end) => {
    let slope = (output_end - output_start) / (input_end - input_start);
    let output = output_start + slope * (input - input_start);
    return output;
  };

  graph && graph.map(level => {
    level.nodes && level.nodes.map(node => {
      nodesColorMap[node.id] = node.color;
      node.edges && node.edges.map(edge => {
        edges.push({
          u: node.id,
          v: edge.nodeId,
          w: edge.edgeWeight,
          breakPoint: "".concat(randomInt(10, 90), "%")
        });
        minEdgeApi = Math.min(minEdgeApi, edge.edgeWeight);
        maxEdgeApi = Math.max(maxEdgeApi, edge.edgeWeight);
      });
    });
  });
  edges.forEach(e => {
    e.w = mapRange(e.w, minEdgeApi, maxEdgeApi, edgeMinWidth, edgeMaxWidth);
    e.sColor = nodesColorMap[e.u];
    e.eColor = nodesColorMap[e.v];
  });
  const rref = (0, _react.useRef)(null);
  const finish = (0, _react.useRef)(null);
  let styles = {
    height: '40px',
    width: '40px',
    borderRadius: '10%',
    border: '1px solid #707070',
    boxShadow: 'rgb(149 157 165 / 20%) 0px 8px 24px',
    display: 'flex',
    justifyContent: 'center',
    padding: '2px'
  };
  (0, _react.useEffect)(() => {
    setDraw(true);
  }, [rref]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, edges && edges.map(e => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("svg", {
      style: {
        height: 0,
        width: 0,
        flex: 0,
        display: 'list-item'
      },
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
      id: "g".concat(e.u, "_").concat(e.v),
      x1: "0.133",
      y1: "0.008",
      x2: "0.949",
      y2: "1.101",
      gradientUnits: "objectBoundingBox"
    }, /*#__PURE__*/_react.default.createElement("stop", {
      offset: "10%",
      "stop-color": e.sColor,
      "stop-opacity": "0.3"
    }), /*#__PURE__*/_react.default.createElement("stop", {
      offset: "90%",
      "stop-color": e.eColor,
      "stop-opacity": "0.3"
    })))), /*#__PURE__*/_react.default.createElement("svg", {
      style: {
        height: 0,
        width: 0,
        flex: 0,
        display: 'list-item'
      }
    }, /*#__PURE__*/_react.default.createElement("use", {
      fill: "url(#g".concat(e.u, "_").concat(e.v, ")")
    })));
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: rref,
    id: "cj-box-all",
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      height: height ? height : '100%',
      width: width ? width : '120%',
      padding: '10px'
    }
  }, graph && graph.map(level => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "cj-level",
      style: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around'
      }
    }, level.nodes && level.nodes.map(node => /*#__PURE__*/_react.default.createElement(_SankeyNode.default, {
      title: node.nodeLabel,
      image: node.image,
      id: node.id,
      color: "red",
      styles: styles
    })));
  }), draw ? /*#__PURE__*/_react.default.createElement("div", {
    ref: finish
  }, edges && edges.map(e => {
    return /*#__PURE__*/_react.default.createElement(_reactXarrows.default, {
      SVGcanvasProps: {
        id: "".concat(e.u, "_").concat(e.v)
      },
      start: e.u //can be react ref
      ,
      end: e.v //or an id
      ,
      strokeWidth: e.w // path='grid'
      ,
      startAnchor: "right",
      endAnchor: "left" //gridBreak = {e.breakPoint}
      //   curveness={0.6}
      ,
      showHead: false,
      showTail: false // animateDrawing={true}
      ,
      color: "url(#g".concat(e.u, "_").concat(e.v, ")")
    });
  })) : null));
}

var _default = Sankey;
exports.default = _default;